import { cloneDeep, uniq } from 'lodash';
import { getFramework } from '@/framework';
import { MaterialIdsType, type ITableLayer } from '@/version-types';
import { collectTableLayerFonts } from './table';

/** 副作用: 该方法会直接对layer对象改属性值 */
export const resetTableLayerMaterialIds = <T extends ITableLayer | ITableLayer<true>>(
    frameworkIdentity: string,
    layer: T,
): T => {
    const allFontList = getFramework(frameworkIdentity).service.font.getFonts();
    const usedFontList = collectTableLayerFonts(layer.data);
    const resultMaterialIds = usedFontList
        .map(({ fontFamily }) => allFontList.find((font) => font.name === fontFamily)?.id)
        .filter((id): id is string => Boolean(id));

    if (!layer.materialIds) {
        layer.materialIds = {};
    }
    layer.materialIds[MaterialIdsType.FONT_FAMILY] = uniq(resultMaterialIds);
    return layer;
};

/**
 * 表格图层的更新.
 * 注: 表格图层的更新不能直接用`framework.service.frame.addOrUpdateLayer`
 */
const addOrUpdateLayer = ({
    frameworkIdentity,
    layer,
    resetMaterialIds,
}: {
    frameworkIdentity: string;
    layer: ITableLayer | ITableLayer<true>;
    /** 如果该操作会影响到materialIds的变化, 则需要重新统计materialIds */
    resetMaterialIds: boolean;
}): ITableLayer => {
    let newLayer = cloneDeep(layer as ITableLayer);

    const framework = getFramework(frameworkIdentity);

    if (resetMaterialIds) {
        resetTableLayerMaterialIds(frameworkIdentity, newLayer);
    }

    newLayer = framework.service.frame.addOrUpdateLayer(newLayer) as ITableLayer;
    return cloneDeep(newLayer);
};

export default addOrUpdateLayer;
